/* eslint-disable no-console */
import axios from "axios";
import ActionTrackerEntry from "../../models/ActionTrackerEntry";
import {
  PrimePoiApiRoot,
  PrimePoiApiPaths,
  MakeAuthHeader
} from "../../config/api";
import FireLog from "../../models/FireLog";

// initial state
const state = {
  loading: false,
  error: null,
  timeout: null
};

const getters = {
  loading(state) {
    return state.loading;
  },
  error(state) {
    return state.error;
  }
};

// actions
const actions = {
  sendError({ commit, rootGetters }, err) {
    if (!navigator.onLine) {
      let action = new ActionTrackerEntry({
        action: "errors/sendError",
        payload: err
      });
      commit("actions/addActions", action, { root: true });
      return;
    }

    let url = `${PrimePoiApiRoot}${PrimePoiApiPaths.JsError}`;
    let config = {
      headers: MakeAuthHeader(rootGetters["login/userToken"])
    };

    let date = new Date();
    let log = new FireLog({
      timestamp: date.toISOString(),
      tag: "FollowUp",
      subTag: err.name,
      message: `message: ${err.message}, name: ${err.name}, stack trace: ${err.stack}, user agent: ${navigator.userAgent}`,
      severity: 3,
      group: "n/a",
      logger: "n/a",
      user: rootGetters["login/userId"]
    });
    return axios
      .post(url, log, config)
      .then(res => {
        return res.data;
      })
      .catch(error => {
        // if this errors then there is nothing we can do really
        console.warn(error);
      });
  },
  unexpectedErrorAlert({ commit }, name) {
    commit("clearTimeout");
    commit(
      "setError",
      `An unexpected error occurred. The application developers should receive the error details shortly.
      
      If the error persists please contact customer service. Error: '${name}'`
    );
    let timer = setTimeout(() => {
      commit("clearError");
    }, 3000);
    commit("setTimeout", timer);
  },
  expectedErrorAlert({ commit }, message) {
    commit("clearTimeout");
    commit("setError", message);
    let timer = setTimeout(() => {
      commit("clearError");
    }, 3000);
    commit("setTimeout", timer);
  }
};

// mutations
const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  clearLoading(state) {
    state.loading = false;
  },
  setError(state, payload) {
    state.error = payload;
  },
  clearError(state) {
    state.error = null;
    clearTimeout(state.timeout);
  },
  setTimeout(state, payload) {
    state.timeout = payload;
  },
  clearTimeout(state) {
    clearTimeout(state.timeout);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
